import React, { Component } from 'react';
import { Row, Col } from 'antd';
class NiprRes extends Component {

  render() {
    const { niprresp } = this.props;
    return (<>
      {(niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.inT_RESPONSE && niprresp.transaction.license.inT_RESPONSE.resP_MESSAGE.find(x => x.actioN_REQD === "Y"))||(niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.inT_RESPONSE && niprresp.transaction.license.loa.inT_RESPONSE.resP_MESSAGE.find(x => x.actioN_REQD === "Y")) ?
        <div className="mi_main" >
          <Row span={24}>
            <Col span={15}>
              <p className='mi_title' style={{ color: '#fd828d' }}>Action Required</p>
            </Col>
          </Row>
          <Row>
            <Col sm={24}>
              {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.inT_RESPONSE && niprresp.transaction.license.inT_RESPONSE.resP_MESSAGE.filter(x => x.actioN_REQD === "Y").map(x => {
                return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.commenT_CODE + ") " + x.comments}</p>
              })}
              {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.inT_RESPONSE && niprresp.transaction.license.loa.inT_RESPONSE.resP_MESSAGE.filter(x => x.actioN_REQD === "Y").map(x => {
                return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.commenT_CODE + ") " + x.comments}</p>
              })}
            </Col>
          </Row>
        </div> : ""}
        {(niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.inT_RESPONSE && niprresp.transaction.license.inT_RESPONSE.resP_MESSAGE.find(x => x.actioN_REQD === "N"))||(niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.inT_RESPONSE && niprresp.transaction.license.loa.inT_RESPONSE.resP_MESSAGE.find(x => x.actioN_REQD === "N"))?
      <div className="mi_main" >
        <Row span={24}>
          <Col span={15}>
            <p className='mi_title' style={{ color: '#fd828d' }}>No Action Required</p>
          </Col>
        </Row>
        <Row>
          <Col sm={24}>
            {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.inT_RESPONSE && niprresp.transaction.license.inT_RESPONSE.resP_MESSAGE.filter(x => x.actioN_REQD === "N").map(x => {
              return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.commenT_CODE + ") " + x.comments}</p>
            })}
            {niprresp && niprresp.transaction && niprresp.transaction.license && niprresp.transaction.license.loa && niprresp.transaction.license.loa.inT_RESPONSE && niprresp.transaction.license.loa.inT_RESPONSE.resP_MESSAGE.filter(x => x.actioN_REQD === "N").map(x => {
              return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.commenT_CODE + ") " + x.comments}</p>
            })}
          </Col>
        </Row>
      </div>:""}
    </>)
  }

}
export default NiprRes;
